import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar, MobileNav, Footer } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Buy from "@/pages/Buy";
import BuyerQuiz from "@/pages/BuyerQuiz";
import Sell from "@/pages/Sell";
import SellerQuiz from "@/pages/SellerQuiz";
import Areas from "@/pages/Areas";
import County from "@/pages/County";
import City from "@/pages/City";
import Search from "@/pages/Search";
import PropertyDetail from "@/pages/PropertyDetail";
import Calculators from "@/pages/Calculators";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Auth from "@/pages/Auth";
import Saved from "@/pages/Saved";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname === "/login" || pathname === "/signup" || pathname.startsWith("/admin");
  return (
    <>
      {!bare && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/buy/questionnaire" element={<BuyerQuiz />} />
          <Route path="/sell" element={<Sell />} />
          <Route path="/sell/questionnaire" element={<SellerQuiz />} />
          <Route path="/areas" element={<Areas />} />
          <Route path="/areas/:slug" element={<County />} />
          <Route path="/areas/:slug/:city" element={<City />} />
          <Route path="/search" element={<Search />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
          <Route path="/calculators" element={<Calculators />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/saved" element={<Saved />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/signup" element={<Auth mode="signup" />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/accessibility" element={<Legal page="accessibility" />} />
          <Route path="/cookies" element={<Legal page="cookie" />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      {!bare && <MobileNav />}
    </>
  );
}

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Shell />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ReactLenis>
  );
}
